<template>
    <div>
        <br />
        <v-card class="box" v-if="show_parent_uid == true">
            <v-row dense>
                <v-col cols="12" sm="12" md="2"></v-col>
                <v-col cols="12" sm="12" md="6">
                    <p><v-icon color="error">*</v-icon><b>Parent Username</b></p>
                    <v-text-field outlined rounded label="Parent Username" v-model="parent_uid" dense
                        readonly></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <p class="hidden-md-and-down"><br /></p>
                    <v-btn class="button usrname" @click="add_parent_uid = true" small>Change Username</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <template v-if="show_addmission_form == true">
            <v-row dense justify="center" v-if="user_type === 'Parent' && items.length == 0">
                <v-col cols="12" sm="12" md="6">
                    <v-card class="box">
                        <center>
                            <h3 v-if="tenant == 'eps' || tenant == 'sbpps'">
                                How To Fill New Admission Form.
                                <a href="https://eduplusschool.s3.ap-south-1.amazonaws.com/New+_admission_form_SBPPS.mp4"
                                    target="_blank">Click here</a>
                            </h3>
                            <h3 v-else-if="tenant == 'sanjivani'">
                                How To Fill New Admission Form.
                                <a href="https://sgs-schoolerp.s3.ap-south-1.amazonaws.com/logo/Sanjivani_Addmission.gif"
                                    target="_blank">Click here</a>
                            </h3>
                            <h3 v-else>
                                How to fill new admission form.
                                <a href="https://wws-schoolerp.s3.ap-south-1.amazonaws.com/documents/Admission_instructions.gif"
                                    target="_blank">Click here</a>
                            </h3>
                            <br />
                            <h3 v-if="tenant == 'eps' || tenant == 'sbpps'">
                                How To Pay School Fee.
                                <a href="https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/Documents/Fees.mp4"
                                    target="_blank">Click here</a>
                            </h3>
                        </center>
                    </v-card>
                </v-col>
            </v-row>
        </template>
        <!-- parent login first time code end -->

        <!-- Employee Section -->
        <template v-if="user_type == 'Employee'">
            <v-card color="#F8E8EE" height="67px" style="margin-top: -5px;">
                <v-row dense class="pt-2">
                    <v-col cols="12" sm="2" md="2" style="margin-top: -30px;">
                        <v-switch dense color="deep-purple" v-model="isDrawer" class="pl-6 pt-6"
                            :label="isDrawer ? 'Menu View' : 'Card View'"></v-switch>
                    </v-col>
                    <v-col cols="12" sm="10" md="10">
                        <updated-employee-profile-card></updated-employee-profile-card>
                    </v-col>
                </v-row>
            </v-card>
            <v-row>
                <v-col cols="12" sm="3" md="3" class="pt-0">
                    <!-- <v-switch dense  color="deep-purple" v-model="isDrawer" class="ma-2 pl-4" :label="isDrawer ? 'Menu View' : 'Card View'"></v-switch> -->
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="!isDrawer">
                    <v-text-field v-model="moduleSearch" append-icon="mdi-magnify" label="Search module" dense
                        outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-combobox required dense clearable :items="search_links" item-text="name" v-model="goto_link"
                        label="Search links" outlined return-object @change="gotoLink">
                        <template v-slot:append>
                            <v-icon class="cursor-pointer" @click="gotoLink">mdi-magnify</v-icon>
                        </template>
                    </v-combobox>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="2" md="2" class="pt-0" v-if="isDrawer">
                    <v-navigation-drawer v-if="isDrawer" app
                        style="position: relative; overflow-y: auto; z-index: 1; margin-top: -90px"
                        :permanent="$vuetify.breakpoint.mdAndUp" :temporary="$vuetify.breakpoint.smAndDown">
                        <v-app-bar dense color="deep-purple" dark>
                            <v-text-field v-model="moduleSearch" append-icon="mdi-magnify" label="Search module..."
                                single-line hide-details></v-text-field>
                        </v-app-bar>
                        <span v-for="(item, j) in filteredItems" :key="j">
                            <v-list dense style="padding: 0;">
                                <v-list-item-group>
                                    <v-list-item @click="openMenuView(item)" class="hover-item"
                                        v-if="item.children.length != 1" style="margin: 0;">
                                        <v-list-item-avatar>
                                            <v-img :src="item.icon"></v-img>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title style="font-size: small;">{{ item.name
                                                }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item @click="openlink(item.children[0])" class="hover-item" v-else
                                        style="margin: 0;">
                                        <v-list-item-avatar>
                                            <v-img :src="item.icon"></v-img>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title style="font-size: small;">{{ item.name
                                                }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </span>
                    </v-navigation-drawer>
                </v-col>
                <v-col cols="12" sm="9" md="9" class="pt-0 pl-5" v-if="!isDrawer">
                    <v-card color="#F8E8EE" style="border-radius: 16px;">
                        <v-card-text>
                            <v-row dense>
                                <v-col md="3" sm="3" cols="12" v-for="(item, j) in filteredItems" :key="j">
                                    <template>
                                        <v-col cols="12">
                                            <!-- <v-card :elevation="2" color="#C4B0FF" @click="openlink(item.children[0])" class="back-hover" v-if="item.children.length != 1"> -->
                                            <v-card :elevation="2" color="#C4B0FF" @click="openEmpRole(item)"
                                                class="back-hover" v-if="item.children.length != 1">
                                                <v-img>
                                                    <br />
                                                    <center>
                                                        <span>
                                                            <v-img style="cursor: pointer;" :src="item.icon"
                                                                width="25%"></v-img>
                                                        </span>
                                                        <strong style="font-size: small;"><span class="linkname">{{
                                                                item.name }}</span></strong>
                                                    </center>
                                                </v-img>
                                                <br />
                                            </v-card>
                                            <v-card :elevation="2" color="#C4B0FF" class="back-hover"
                                                @click="openlink(item.children[0])" v-else>
                                                <v-img>
                                                    <br />
                                                    <center>
                                                        <span>
                                                            <v-img style="cursor: pointer;" :src="item.icon"
                                                                width="25%"></v-img>
                                                        </span>
                                                        <strong style="font-size: small;"><span class="linkname">{{
                                                                item.name }}</span></strong>
                                                    </center>
                                                </v-img>
                                                <br />
                                            </v-card>
                                        </v-col>
                                    </template>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="7" md="7" v-if="isDrawer" class="pl-9 pt-0" style="margin-top: -20px;">
                    <!-- <v-container fluid> -->
                    <v-row dense v-if="emp_role != ''" justify="start" align="center">
                        <v-col cols="12" sm="4" md="3" lg="3" v-for="(item, j) in emp_role.children" :key="j"
                            class="d-flex justify-center">
                            <v-card
                                style="margin: 8px; width: 100%; max-width: 200px; height: 150px; display: flex; flex-direction: column; align-items: center; justify-content: center;"
                                :elevation="4" color="#C4B0FF" class="back-hover" @click="openlink(item)">
                                <v-avatar class="avatar-icon circle2" size="60">
                                    <span>
                                        <h2 class="pa-1" style="font-size: 1.5vw;"> {{ getInitials(item.name) }} </h2>
                                    </span>
                                </v-avatar>
                                <strong class="pb-2" style="font-size: 1vw; text-align: center; margin-top: 8px;">
                                    <span class="linkname">{{ item.name }}</span>
                                </strong>
                            </v-card>
                        </v-col>
                    </v-row>
                    <!-- </v-container> -->
                </v-col>
                <v-col cols="12" sm="3" md="3" style="justify-items: center; margin-top: -20px;" class="pl-10 pt-0">
                    <div style="max-width: 500px;">
                        <v-btn @click="my_calender" text color="#58355e">
                            <v-icon class="mr-2" color="warning">mdi-calendar-today</v-icon>
                            <b style="font-size: small;">My Calendar</b>
                        </v-btn>
                        <v-btn @click="module_management" text color="#58355e">
                            <v-icon class="mr-2" color="warning">mdi-book-multiple</v-icon>
                            <b style="font-size: small;">Module Management</b>
                        </v-btn>
                        <template v-if="lib_url && erp_lib_flag == 'YES'">
                            <form :action="lib_url" name="library" target="_blank" method="post" v-if="flag">
                                <input name="prn" type="hidden" id="udf2" :value="prn" />
                                <input name="tenant" type="hidden" id="tenant" :value="tenant" />
                                <input name="random_key" type="hidden" id="udf2" :value="random_key" />
                                <input name="uid" type="hidden" id="udf2" :value="uid" />
                                <input name="hash_key" type="hidden" id="udf2" :value="hash_key" />
                                <input name="erp_url" type="hidden" id="udf2" :value="erp_url" />
                                <input name="device_name" type="hidden" id="device_name" :value="device_name" />
                                <input name="org_code" type="hidden" id="org_code" :value="org_code" />
                                <v-btn type="submit" text color="#58355e">
                                    <v-icon class="mr-2" color="warning">mdi-library</v-icon>
                                    <b style="font-size: small;">Library</b>
                                </v-btn>
                            </form>
                        </template>
                        <br />
                        <v-card color="#F8E8EE">
                            <v-col cols="12" sm="12" md="12">
                                <updated-employee-right-section />
                            </v-col>
                        </v-card>
                        <br />
                        <v-card color="#F8E8EE">
                            <center>
                                <h4 style="color: firebrick;">Quick Links</h4>
                            </center>
                            <span v-if="quick_links != ''">
                                <span v-for="(link, i) in quick_links" :key="i">
                                    <router-link class="menulink" style="color: #58355e;" :to="{ name: link.link }">
                                        <v-list-item>
                                            <v-avatar>
                                                <v-icon color="warning">mdi-star-circle</v-icon>
                                            </v-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title class="linkname"> {{ link.name }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </router-link>
                                </span>
                            </span>
                            <span v-else>
                                <center>
                                    <h4 class="ml-2" style="color: #58355e;">No Quick Links Added</h4>
                                </center>
                            </span>
                        </v-card>
                        <!-- <v-card color="#F8E8EE">
                          <center>
                              <h4 style="font-family: Arial, Helvetica, sans-serif; color: firebrick; height: 28px;">
                                  Special Features
                              </h4>
                          </center>
                          <v-col cols="12" sm="12" md="12">
                              <v-btn @click="dialog_speechtotext = true" text title="Speech To Text" color="#58355e">
                                  <v-icon class="mr-2" color="warning" small title="Speech To Text">mdi-microphone </v-icon>
                                  <b>Speech To Text</b>
                              </v-btn>
                              <br />
                              <v-btn @click="openeditor()" title="Editor" text color="#58355e">
                                  <v-icon class="mr-2" color="warning" small title="Editor">mdi-file-edit-outline</v-icon>
                                  <b>Editor</b>
                              </v-btn>
                          </v-col>
                      </v-card> 
                      <br>-->
                    </div>
                </v-col>
            </v-row>
        </template>
        <!-- Parent Student Section -->
        <template v-else>
            <v-row dense justify="left">
                <v-switch dense color="deep-purple" v-model="isDrawer" class="ma-2 pl-4 pt-2 pb-0"
                    :label="isDrawer ? 'Menu View' : 'Card View'"></v-switch>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="2" md="2" v-if="isDrawer">
                    <v-navigation-drawer v-if="isDrawer" app
                        style="position: relative; overflow-y: auto; z-index: 1; margin-top: -20px; ">
                        <v-app-bar dense color="deep-purple" dark>
                            <v-text-field v-model="moduleSearch" append-icon="mdi-magnify" label="Search module..."
                                single-line hide-details></v-text-field>
                        </v-app-bar>
                        <v-list>
                            <v-list-item v-for="(item, j) in filteredItems" :key="j"
                                @click="openlink(item.children[0])">
                                <v-list-item-icon>
                                    <v-img :src="item.icon" width="30px"></v-img>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-navigation-drawer>
                </v-col>
                <v-col cols="12" sm="7" md="7" class="pa-6" v-if="isDrawer">
                    <!-- <parent-upcoming-events v-if="user_type == 'Parent' && items.length != 0"></parent-upcoming-events>
                    <parent-upcoming-events
                        v-else-if="user_type == 'Student' && items.length != 0"></parent-upcoming-events> -->
                </v-col>
                <v-col cols="12" sm="9" md="9" class="pt-0" v-if="!isDrawer">
                    <v-card color="#F8E8EE" style="border-radius: 16px;">
                        <v-card-text>
                            <v-row dense>
                                <v-col md="3" v-for="(item, j) in items" :key="j">
                                    <template>
                                        <v-col cols="12">
                                            <v-card :elevation="2" color="#C4B0FF" class="back-hover"
                                                @click="openlink(item.children[0])">
                                                <v-img>
                                                    <br />
                                                    <center>
                                                        <span>
                                                            <v-img style="cursor: pointer;" :src="item.icon"
                                                                width="25%"></v-img>
                                                        </span><br>
                                                        <strong style="font-size: small;"><span class="linkname">{{
                                                                item.name }}</span></strong>
                                                    </center>
                                                </v-img><br>

                                                <!-- <v-tabs show-arrows background-color="#C4B0FF" class="tabsname">
                                                  <v-tabs-slider style="width: 0;"></v-tabs-slider>
                                                  <v-tab class="tab_name" v-for="(child, i) in item.children" :key="i" @click="openlink(child)">
                                                      <span class="tabname"> {{ child.name }}</span>                                                     
                                                  </v-tab>
                                                  <v-spacer></v-spacer>
                                              </v-tabs> -->
                                            </v-card>
                                        </v-col>
                                    </template>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <!-- <parent-upcoming-events v-if="user_type == 'Parent' && items.length != 0"></parent-upcoming-events>
                    <parent-upcoming-events
                        v-else-if="user_type == 'Student' && items.length != 0"></parent-upcoming-events> -->
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <!-- <v-row dense justify="center">
                    <v-switch dense color="deep-purple" v-model="isDrawer" class="ma-2 pl-4" :label="isDrawer ? 'Menu View' : 'Card View'"></v-switch>
                </v-row> -->
                    <parent-profile-card v-if="user_type == 'Parent'"></parent-profile-card>
                    <parent-profile-card v-else-if="user_type == 'Student'"></parent-profile-card>
                    <v-card color="#F8E8EE">
                        <v-row dense justify="center">
                            <v-col cols="12" md="9" sm="9" class="mt-3">
                                <v-combobox required dense clearable :items="search_links" item-text="name"
                                    v-model="goto_link" label="Search links" outlined rounded return-object
                                    @change="gotoLink">
                                    <template v-slot:append>
                                        <v-icon class="cursor-pointer" @click="gotoLink">mdi-magnify</v-icon>
                                    </template>
                                </v-combobox>
                            </v-col>
                        </v-row>
                        <span v-if="quick_links != ''">
                            <center>
                                <h4 class="ml-2">Quick Links</h4>
                            </center>
                            <span v-for="(link, i) in quick_links" :key="i">
                                <router-link class="menulink" :to="{ name: link.link }">
                                    <v-list-item>
                                        <v-avatar>
                                            <v-icon color="black">mdi-arrow-right-bold-hexagon-outline</v-icon>
                                        </v-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title class="linkname"> {{ link.name }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </router-link>
                            </span>
                        </span>
                        <span v-else>
                            <center>
                                <h4 class="ml-2">No Quick Links Added</h4>
                            </center>
                        </span>
                    </v-card>
                </v-col>
            </v-row>

        </template>

        <br />

        <template v-if="easycheck_url && erp_easycheck_flag == 'YES'">
            <form :action="easycheck_url" name="easycheck" method="POST" v-if="flag">
                <input name="uid" type="hidden" id="udf2" :value="uid" />
                <input name="hash_key" type="hidden" id="udf2" :value="hash_key" />
                <input name="erp_url" type="hidden" id="udf2" :value="erp_url" />
                <input name="device_name" type="hidden" id="device_name" :value="device_name" />
                <center>
                    <v-btn class="button" rounded type="submit" text color="green" large>
                        <strong>Proceed To EasyCheck</strong>
                    </v-btn>
                </center>
            </form>
        </template>

        <br />


        <v-dialog v-model="add_parent_uid" max-width="950px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>Change Username</strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="6" md="6">
                                <p><b>Enter Email*</b></p>
                                <v-text-field v-model="parent_email" :rules="[rules.required, rules.uid]"
                                    prepend-icon="email" placeholder="Please Enter email" clearable :hint="disabled == 1
                                            ? 'noneditable'
                                            : 'For example, admin@edupluscampus.com'
                                        " :disabled="disabled == 1 ? true : false" required></v-text-field>
                                <p><b>Note:--This Will Be Your Login Id</b></p>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="3"></v-col>
                            <v-col cols="12" sm="9">
                                <v-checkbox v-model="policy_read"
                                    label="I agree to receive email from School ERP"></v-checkbox>
                                <span><b>Above Email ID will be considered as preferred communication
                                        details.</b></span>
                                <div class="error-message" v-if="error">
                                    {{ error_message }}
                                </div>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="3">
                                <v-layout align-center justify-center v-if="hideen">
                                    <v-btn class="mr-4 button" :disabled="!policy_read" :loading="send_otp_btn_load"
                                        @click="sendotp">Request OTP</v-btn>
                                </v-layout>
                            </v-col>
                        </v-row>
                        <v-card-text v-if="verify_block == true">
                            <v-row justify="center" dense>
                                <v-col sm="5">
                                    <v-text-field v-model="user.email_otp" placeholder="Please Enter OTP"
                                        hint="Enter OTP" persistent-hint clearable required></v-text-field>
                                </v-col>
                                <v-col sm="2">
                                    <v-btn class="button" @click="sendotp()" :disabled="resend_email_otp_btn"
                                        :loading="resend_email_otp_load" title="Resend OTP">resend</v-btn>
                                </v-col>
                            </v-row>
                            <v-layout align-center justify-center v-if="hideen">
                                <v-btn class="mr-4 button" :loading="verify_btn_load" @click="verifyotp">Proceed</v-btn>
                            </v-layout>
                            {{ email_msg }}
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_speechtotext" width="1000px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-toolbar class="toolbar" flat dense>
                            <v-btn icon dark @click="dialog_speechtotext = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Speech To Text</v-toolbar-title>
                        </v-toolbar>
                    </v-card>
                    <!-- calendar content start -->

                    <v-card class="box">
                        <speech-to-text></speech-to-text>
                    </v-card>
                    <!-- calendar content end -->
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_inst_cal" width="1000px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-toolbar class="toolbar" flat dense>
                            <v-btn icon dark @click="dialog_inst_cal = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>My Calendar</v-toolbar-title>
                        </v-toolbar>

                        <instructor_calendar :events="events"></instructor_calendar>
                    </v-card>
                    <!-- calendar content end -->
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dailog_role" persistent max-width="1000px" transition="dialog-bottom-transition">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <!-- {{ emp_role }} -->
                        <v-row dense justify="center">
                            <v-col cols="12" sm="4" md="4" v-for="(item, j) in emp_role.children" :key="j">
                                <template>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-card fill-height style="margin: 8px; height: 190%;" :elevation="4"
                                            color="#C4B0FF" class="back-hover" @click="openlink(item)">
                                            <center> <v-avatar class="avatar-icon circle2" size="60">
                                                    <span>
                                                        <h2 class="pa-1"> {{ getInitials(item.name) }} </h2>
                                                    </span>
                                                </v-avatar> <br>
                                                <strong style="font-size: medium;"><span class="linkname">{{ item.name
                                                        }}</span></strong>
                                            </center>
                                        </v-card>
                                    </v-col>
                                </template>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-btn color="primary" text @click="dailog_role = false">Close</v-btn>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
    components: {
        "updated-employee-right-section": () => import("./UpdatedEmployeeRightSection.vue"),
        updatedEmployeeProfileCard: () => import("./UpdatedEmployeeProfileCard.vue"),
        parentProfileCard: () => import("./ParentProfileCard.vue"),
        parentUpcomingEvents: () => import("./ParentUpcomingEvents.vue"),
        instructor_calendar: () => import("../Academics/AcademicPlanner/InstructorCalendar"),
        editer: () => import("../Editer"),
        "speech-to-text": () => import("../TryNError/SpeechToText"),
    },

    data() {
        return {
            editorConfig: {
                height: "100px",
                extraPlugins: "mathjax",
                mathJaxLib: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
            },
            quick_links: [],
            policy_read: false,
            send_otp_btn_load: false,
            error: false,
            email_msg: null,
            error_message: "",
            error1: false,
            error_message1: "",
            hideen: true,
            dialog_calendar: false,
            dialog_speechtotext: false,
            dialog_Editor: false,
            disabled: 0,
            isClosed: false,
            events: [],
            user: {
                otp_id: "",
                email: "",
                email_otp: "",
                mobile: "",
                mobile_otp: "",
                dns: "",
            },
            parent_email: "",
            rules: {
                required: (value) => !!value || "Required.",
                uid: (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            },
            show_parent_uid: false,
            items: [],
            module_link: false,
            search_links: [],
            goto_link: null,
            easycheck_url: "http://localhost:8080", //live url
            lib_url: "http://localhost:8080", //live url
            uid: "",
            prn: "",
            random_key: "",
            hash_key: "",
            flag: false,
            erp_url: "",
            device_name: "",
            erp_easycheck_flag: null,
            erp_lib_flag: null,
            resend_email_otp_load: false,
            temp_card: "card",
            show_parent_uid: false,
            parent_uid: "",
            add_parent_uid: false,
            verify_block: false,
            verify_btn_load: false,
            user_type: null,
            tenant: "sbpps",
            show_addmission_form: false,
            org_code: "",
            dialog_inst_cal: false,
            isDrawer: false,
            moduleSearch: "",
            emp_role: [],
            dailog_role: false
        };
    },
    computed: {
        filteredItems() {
            if (!this.moduleSearch) return this.items;
            return this.items.filter((item) => item.name && item.name.toLowerCase().includes(this.moduleSearch.toLowerCase()));
        },
    },
    methods: {
        getInitials(name) {
            // Split the name into words, get the first letter of each word, and join them
            return name
                .split(" ")
                .map((word) => word[0].toUpperCase())
                .join("");
        },
        sliderCloseOpen(val) {
            var quickslidediv = document.getElementById("module_link_slider1");
            if (val) {
                quickslidediv.style.left = "28px";
                this.isClosed = true;
            } else {
                this.isClosed = false;
                quickslidediv.style.right = "0px";
            }
        },
        openeditor() {
            let routeData = this.$router.resolve({
                name: "editor",
            });
            window.open(routeData.href, "_blank");
        },
        sendotp() {
            //api-1
            if (this.parent_email == "" || this.parent_email == null) {
                this.message = "Please Enter Email-Id";
                return;
            }
            this.send_otp_btn_load = true;
            this.user.dns = window.location.hostname;
            //this.user.dns = "localhost"
            this.user.email = this.parent_email;
            axios
                .post("/login/sendOtpForUpdateUid", this.user)
                .then((res) => {
                    console.log(res);
                    if (res.data.status == "NO") {
                        alert(res.data.status_reason);
                    } else {
                        this.otp_block = false;
                        this.verify_block = true;
                        (this.policy_read = false), (this.email_msg = res.data.email_msg);
                        this.user.otp_id = res.data.otp_id;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                    this.message = "Something went wrong";
                })
                .finally(() => {
                    this.send_otp_btn_load = false;
                });
        },
        verifyotp() {
            //api-2

            if (this.user.email_otp != "") {
                this.verify_btn_load = true;
                const formData = {
                    email: this.parent_email,
                    email_otp: this.user.email_otp,
                    parent_uid: this.parent_uid,
                };
                axios
                    .post("/login/verifyotpForUpdateUid", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.add_parent_uid = false;
                            this.parent_uid = res.data.parent_uid;
                            (this.verify_block = false), (this.user.email_otp = "");
                            alert(res.data.status_reason);
                        } else {
                            alert(res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.message = "Something went wrong";
                    })
                    .finally(() => {
                        this.verify_btn_load = false;
                    });
            } else {
                alert("Please enter otp!!!");
            }
        },
        //click method for Module Management
        module_management() {
            this.$router.push("/role-dashboard/modules");
        },
        my_calender() {
            this.dialog_inst_cal = true;
            //  this.$router.push({name: "instructor-planner"});
            //  this.$router.push("/role-dashboard/instructor-planner");
        },
        openMenuView(item) {
            this.emp_role = []
            //  console.log("item:::"+item)
            this.emp_role = item
        },
        //   openEmpRole(item){

        //     localStorage.setItem("emp_role", JSON.stringify(item));
        //       if (item.direct_link != null) {
        //           this.$router.push({ name: item.direct_link });
        //           return;
        //       }
        //     this.$router.push("/emp-role-dashboard");
        //   },
        openEmpRole(item) {
            // Store emp_role in sessionStorage
            sessionStorage.setItem("emp_role", JSON.stringify(item));



            // Redirect user
            if (item.direct_link != null) {
                this.$router.push({ name: item.direct_link });
                return;
            }

            this.$router.push("/emp-role-dashboard");
        },
        openlink(child) {
            sessionStorage.removeItem("para_role");
            sessionStorage.setItem("emp_role", JSON.stringify(child));
            localStorage.setItem("para_role", child.para_role);
            if (child.direct_link != null) {
                // console.log("hi")
                this.$router.push({ name: child.direct_link });
                // this.$router.push("/role-dashboard/"+child.direct_link);
                return;
                // this.$router.push({name: child.direct_link});
            }

            this.$router.push({
                name: child.link,
                params: {
                    role_type: child.para_role_type,
                    role_name: child.para_role,
                },
            });
        },
        getCalandar() {
            // alert("in getCalandar")
            this.$store.commit("setcalendar_flag", this.$store.state.calendar_flag);
            this.events = new Date();
            axios
                .get("communication/getInstructorDateData")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if (res.data.inst_data.length !== null) {
                            this.events = res.data.inst_data;
                            console.log(this.events);
                        }
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },

        gotoLink() {
            if (this.goto_link != null) {
                if (this.search_links.includes(this.goto_link)) {
                    sessionStorage.removeItem("emp_role");
                    sessionStorage.removeItem("para_role");
                    sessionStorage.removeItem("sblinks");

                    // Set correct session storage values
                    sessionStorage.setItem("search_para_role", this.goto_link.para_role);
                    sessionStorage.setItem("search_para_role_type", this.goto_link.search_para_role_type);
                    sessionStorage.setItem("search_link", this.goto_link.name); 

                    
                    let routeData = this.$router.resolve({ name: this.goto_link.link });
                    //this.goto_link=null;
                    window.open(routeData.href, "_blank");
                }
            }
        },
    },

    mounted() {
        // return;
        // this.flag = false;
        if (this.user_type == "Employee") {
            this.getCalandar();
        }
        axios
            .get("/home/dashboardsidebar")
            .then((res) => {
                this.items = res.data.links;
                this.module_link = res.data.to_show_module_management;
                this.search_links = res.data.search_links;
                this.erp_easycheck_flag = res.data.erp_easycheck_flag;
                this.erp_lib_flag = res.data.erp_lib_flag;
                this.show_parent_uid = res.data.show_parent_uid;
                this.parent_uid = res.data.parent_uid;
                this.show_addmission_form = true;

                this.quick_links = res.data.quick_links;
                //added by vrushali

                if (res.data.erp_easycheck_flag == "YES") {
                    this.uid = res.data.uid;
                    this.easycheck_url = res.data.url;
                    this.erp_url = res.data.erp_url;
                    this.hash_key = res.data.key;
                    this.flag = true;
                }
                // alert(res.data.erp_lib_flag)
                if (res.data.erp_lib_flag == "YES") {
                    this.uid = res.data.uid;
                    this.prn = res.data.prn;
                    this.random_key = res.data.random;
                    this.lib_url = res.data.url;
                    this.erp_url = res.data.erp_url;
                    this.hash_key = res.data.key;
                    this.org_code = res.data.org_code;
                    this.flag = true;
                }

                // console.log("items", this.items);
            })
            .catch((error) => {
                window.console.log(error);
                this.$router.push("/");
            });

        // console.log(items);
    },
    created() {
        this.user_type = localStorage.getItem("EPS-ut");
        this.tenant = localStorage.getItem("EPS-tenant");
    },
};
</script>

<style scoped>
.circle2 {
    margin: auto;
    width: 60px;
    height: 60px;
    margin-top: 35px;
    margin-bottom: 35px;
    /* padding-top: 10px; */
    background: white;
    border-radius: 50%;
}

.hover-item:hover {
    background-color: rgb(235, 222, 247);
    color: white;
    cursor: pointer;
    border-radius: 8px;
    transition: background-color 0.3s ease;
}

.card {
    margin: 8px;
    height: 100%;
    border-radius: 20px !important;
    /* color: orange; */
    /* background-color: #D3D3D3; */
    /* background-color: #f4a688; */
    /* color: #674d3c; */
    background-image: linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%);
    color: rgb(128 2 112);
}

.card1 {
    margin: 8px;
    height: 100%;
    border-radius: 20px !important;
    /* color: orange; */
    /* background-color: #D3D3D3; */
    /* background-color: #f4a688; */
    /* color: #674d3c; */
    background-color: #00f88a;
    color: #485f3f;
}

router-link:hover {
    color: red;
}

.card:hover {
    background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%);

    color: rgb(128 2 112) !important;
    font-weight: bold !important;
    text-align: center;
    box-shadow: 20px 20px 20px grey !important;
    -webkit-transition: box-shadow 0.3s ease-in !important;
}

.card1:hover {
    background: #bdc3c7;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, var(--v-brand-base), var(--v-brandLight-base));
    /* Chrome 10-25, Safari 5.1-6 */
    /* background: linear-gradient(to right, #aa221b, #e94e4e); */
    background: linear-gradient(to right, #ffff66, #edf038);

    color: rgb(128 2 112) !important;
    font-weight: bold !important;
    text-align: center;
    box-shadow: 20px 20px 20px #f4a688 !important;
    -webkit-transition: box-shadow 0.3s ease-in !important;
}

.back-hover {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    border-radius: 16px !important;
}

.back-hover:hover {
    transform: translateY(-8px);
    box-shadow: 20px 20px 20px grey !important;
}

.v-avatar.elevated-avatar {
    border: 2px solid #5c6bc0;
    background: linear-gradient(to right, #9575cd, #7986cb);
    color: white;
}

.tabs {
    border-radius: 12px;

    /* color:greenyellow !important; */
    /* background-color: transparent !important; */
    /* background-color="#440ced" */
    /* background-color="#674d3c" */
    /* background-color: "#6599FF"; */
}

v-card {
    border-radius: 22px;
}

.menulink {
    text-decoration: none;
}

.avatar_info_icon {
    opacity: 0.7;
    margin-left: 5px;
    margin-top: 5px;
}

.avatar_video_icon {
    opacity: 0.7;
    margin-right: 5px;
    margin-top: 5px;
}

.tab_name {
    margin: -10px;
    /* margin-left:-10px */
}

.tab_name:hover {
    font-weight: bolder !important;
    color: white;
}

.tabname {
    color: blue;
    font-size: smaller;
}

.tabname:hover {
    color: rgb(241, 12, 241);
}

.linkname {
    cursor: pointer;
}

.search-bar {
    width: 30%;
}

@media (max-width: 920px) {
    .search-bar {
        width: 80%;
    }

    body {
        overflow-x: hidden;
        width: 100%;
    }

    .custom4cols {
        /* width: 35%;
max-width: 35%;
flex-basis: 35%; */
        width: 50%;
        max-width: 50%;
        flex-basis: 50%;
    }

    .usrname {
        margin-top: 2%;
    }
}

.custom4cols {
    width: 50%;
    max-width: 50%;
    flex-basis: 50%;
}

.custom7cols {
    width: 14%;
    max-width: 14%;
    flex-basis: 14%;
}

.button {
    border: 2px solid white !important;
    color: #0f2027;
    /* background: transparent !important; */
    border-radius: 50px !important;
    margin: 0.5rem !important;
    background-color: white !important;
}

.button:hover {
    color: white !important;
    background: #ffc200 !important;
}
</style>